import React from 'react';
import { Menu, X, Github, Calculator, Compass } from 'lucide-react';
import logo from '../../logo1.png';
import ThemeToggle from '../ui/ThemeToggle';

const Navbar = ({ onMenuToggle, onHomeClick, onNavigate, currentView }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/70 dark:bg-slate-950/70 backdrop-blur-xl border-b border-slate-100 dark:border-slate-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <button 
          onClick={onHomeClick}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        >
          <img src={logo} alt="CUCalc Logo" className="w-12 h-12 object-contain" />
          <span className="text-xl font-black bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-400">
            CUCalc
          </span>
        </button>
        
        <div className="flex items-center gap-3">
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-3">
             <button 
              onClick={() => onNavigate('campus')}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-200 font-medium ${
                currentView === 'campus' 
                  ? 'bg-indigo-600 text-white shadow-md' 
                  : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 border border-slate-200 dark:border-slate-700'
              }`}
            >
              <Compass size={18} />
              <span>Community</span>
            </button>

            <div className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800 px-1 py-1 rounded-2xl transition-colors">
            <button 
              onClick={onHomeClick}
              className={`px-4 py-2 rounded-xl text-sm font-bold transition-all ${
                 currentView !== 'campus' 
                 ? 'bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm'
                 : 'text-slate-500 hover:text-slate-700 dark:text-slate-400'
              }`}
            >
              Calculators
            </button>
            </div>
          </div>

          {/* Mobile Campus Shortcut */}
          <button 
            onClick={() => onNavigate('campus')}
            className="md:hidden p-2 text-indigo-600 hover:bg-indigo-50 dark:text-indigo-400 dark:hover:bg-slate-800 rounded-lg transition-colors mr-1"
            aria-label="Go to Community"
          >
            <Compass size={22} />
          </button>

          <ThemeToggle />

          {/* Mobile Menu Toggle */}
          <button 
            onClick={onMenuToggle}
            className="lg:hidden p-2.5 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors"
          >
            <Menu size={24} className="text-slate-700 dark:text-slate-300" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
